import { render, staticRenderFns } from "./LinkDomainsToOrganizationPopup.vue?vue&type=template&id=7901b357&scoped=true"
import script from "./LinkDomainsToOrganizationPopup.vue?vue&type=script&lang=js"
export * from "./LinkDomainsToOrganizationPopup.vue?vue&type=script&lang=js"
import style0 from "./LinkDomainsToOrganizationPopup.vue?vue&type=style&index=0&id=7901b357&prod&lang=scss"
import style1 from "./LinkDomainsToOrganizationPopup.vue?vue&type=style&index=1&id=7901b357&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7901b357",
  null
  
)

export default component.exports